import CONSTANTS from 'src/store/constants';

// NOTE: not used right now because datasets need to be migrated to support
// recent status
export const onbFilters = (selectedCode, filter = { filters: [] }) => {
  switch (selectedCode) {
    case CONSTANTS.TAL_MODEL.FILTER.ERRORED: {
      filter.filters.push({
        name: 'recent_status',
        op: 'in',
        val: [
          CONSTANTS.ONBOARDING_STATUS.API.RECEIVED_RAW_CLIENT_UPLOAD_FAILURE,
          CONSTANTS.ONBOARDING_STATUS.API.ACCEPTED_RAW_CLIENT_UPLOAD_FAILURE,
          CONSTANTS.ONBOARDING_STATUS.API.PROCESSED_BY_DET_FAILURE,
        ],
      });
      break;
    }
    case CONSTANTS.TAL_MODEL.FILTER.COMPLETED: {
      filter.filters.push({
        name: 'recent_status',
        op: 'in',
        val: [CONSTANTS.TAL_MODEL.STATE.LIFT_CHART_GENERATION_SUCCESS],
      });
      break;
    }
    case CONSTANTS.TAL_MODEL.FILTER.PENDING_APPROVAL: {
      filter.filters.push({
        name: 'recent_status',
        op: 'in',
        val: [CONSTANTS.TAL_MODEL.STATE.PENDING_APPROVAL, CONSTANTS.ONBOARDING_STATUS.API.WAITING_FOR_APPROVAL],
      });
      break;
    }
    case CONSTANTS.TAL_MODEL.FILTER.IN_PROGRESS: {
      filter.filters.push({
        name: 'recent_status',
        op: 'in',
        val: [
          CONSTANTS.ONBOARDING_STATUS.API.RECEIVED_RAW_CLIENT_UPLOAD,
          CONSTANTS.ONBOARDING_STATUS.API.ACCEPTED_RAW_CLIENT_UPLOAD,
          CONSTANTS.ONBOARDING_STATUS.API.RECEIVED_CLIENT_UPLOAD,
          CONSTANTS.ONBOARDING_STATUS.API.ACCEPT_CLIENT_UPLOAD,
          CONSTANTS.ONBOARDING_STATUS.API.PROCESSED_BY_DET,
          CONSTANTS.ONBOARDING_STATUS.API.APPROVED_BY_ADMIN,
          CONSTANTS.ONBOARDING_STATUS.API.EXTRACTED_FOR_PUSH,
          CONSTANTS.ONBOARDING_STATUS.API.PACKAGED_FOR_PROVIDER,
          CONSTANTS.ONBOARDING_STATUS.API.PUSHED_TO_PROVIDER,
          CONSTANTS.ONBOARDING_STATUS.API.READY_FOR_PROVIDER,
          CONSTANTS.ONBOARDING_STATUS.API.RECEIVED_FROM_PROVIDER,
        ],
      });
      break;
    }
    default:
      filter.filters.push({
        name: 'recent_status',
        op: 'in',
        val: CONSTANTS.TAL_MODEL.STATES,
      });
      break;
  }
  return filter;
};

/**
 * mdlFilters - builder for model filters from selectedCode and siteRole
 * @param {string} selectedCode - the status filter (COMPLETED, IN_PROGRESS, etc.)
 * @param {"CLASSIFIER"|"ACTUARIAL"|"ALL"|null|undefined} selectedClass - the model class filter
 * @param {string} siteRole - the site role of the user
 * @param {{filters: object[]=, order_by: object[]=, fields: string=}}
 */
export const mdlFilters = (
  selectedCode,
  selectedClass,
  siteRole = CONSTANTS.ROLE.CLIENT_USER,
  filter = { filters: [] }
) => {
  const isClientUser = siteRole === CONSTANTS.ROLE.CLIENT_USER;
  switch (selectedCode) {
    case CONSTANTS.TAL_MODEL.FILTER.PENDING_APPROVAL: {
      filter.filters.push({
        name: 'recent_status',
        op: 'in',
        val: [CONSTANTS.TAL_MODEL.STATE.PENDING_APPROVAL],
      });
      break;
    }
    case CONSTANTS.TAL_MODEL.FILTER.IN_PROGRESS: {
      filter.filters.push({
        name: 'recent_status',
        op: 'in',
        val: [
          CONSTANTS.TAL_MODEL.STATE.SPLIT_DATASET_INITIATED,
          CONSTANTS.TAL_MODEL.STATE.SPLIT_DATASET_SUCCESS,
          CONSTANTS.TAL_MODEL.STATE.APPROVED,
          CONSTANTS.TAL_MODEL.STATE.MODEL_GENERATION_INITIATED,
          CONSTANTS.TAL_MODEL.STATE.MODEL_GENERATION_INITIATED,
          CONSTANTS.TAL_MODEL.STATE.MODEL_GENERATION_SUCCESS,
          CONSTANTS.TAL_MODEL.STATE.LIFT_CHART_GENERATION_INITIATED,
          CONSTANTS.TAL_MODEL.STATE.MODEL_REMEDIATION_INITIATED,
          CONSTANTS.TAL_MODEL.STATE.MODEL_REMEDIATION_SETUP,
          CONSTANTS.TAL_MODEL.STATE.SPLIT_DATASET_INITIATED,
          CONSTANTS.TAL_MODEL.STATE.SPLIT_DATASET_SUCCESS,
        ].concat(
          isClientUser
            ? [
                CONSTANTS.TAL_MODEL.STATE.LIFT_CHART_GENERATION_SUCCESS,
                CONSTANTS.TAL_MODEL.STATE.MODEL_REMEDIATION_PENDING,
                CONSTANTS.TAL_MODEL.STATE.MODEL_REMEDIATION_SETUP_SUCCESS,
              ]
            : []
        ),
      });
      break;
    }
    case CONSTANTS.TAL_MODEL.FILTER.ERRORED: {
      filter.filters.push({
        name: 'recent_status',
        op: 'in',
        val: [
          CONSTANTS.TAL_MODEL.STATE.MODEL_GENERATION_FAILURE,
          CONSTANTS.TAL_MODEL.STATE.LIFT_CHART_GENERATION_FAILURE,
          CONSTANTS.TAL_MODEL.STATE.MODEL_REMEDIATION_SETUP_FAILURE,
          CONSTANTS.TAL_MODEL.STATE.MODEL_REMEDIATION_FAILURE,
        ],
      });
      break;
    }
    case CONSTANTS.TAL_MODEL.FILTER.COMPLETED: {
      filter.filters.push({
        name: 'recent_status',
        op: 'in',
        val: [
          CONSTANTS.TAL_MODEL.STATE.MODEL_REMEDIATION_SUCCESS,
          CONSTANTS.TAL_MODEL.STATE.LIFT_CHART_GENERATION_SUCCESS,
        ].concat(
          !isClientUser
            ? [
                CONSTANTS.TAL_MODEL.STATE.MODEL_REMEDIATION_PENDING,
                CONSTANTS.TAL_MODEL.STATE.MODEL_REMEDIATION_SETUP_SUCCESS,
              ]
            : []
        ),
      });
      break;
    }
    default:
      filter.filters.push({
        name: 'recent_status',
        op: 'in',
        val: CONSTANTS.TAL_MODEL.STATES,
      });
      break;
  }
  switch (selectedClass) {
    case CONSTANTS.TAL_MODEL.MODEL_CLASS.CLASSIFIER: {
      filter.filters.push({
        name: 'data_model_type',
        op: 'in',
        val: [CONSTANTS.TAL_MODEL.MODEL_CLASS.CLASSIFIER],
      });
      break;
    }
    case CONSTANTS.TAL_MODEL.MODEL_CLASS.ACTUARIAL: {
      filter.filters.push({
        name: 'data_model_type',
        op: 'in',
        val: [CONSTANTS.TAL_MODEL.MODEL_CLASS.ACTUARIAL],
      });
      break;
    }
    case CONSTANTS.TAL_MODEL.MODEL_CLASS.ALL:
    default:
      filter.filters.push({
        name: 'data_model_type',
        op: 'in',
        val: [CONSTANTS.TAL_MODEL.MODEL_CLASS.CLASSIFIER, CONSTANTS.TAL_MODEL.MODEL_CLASS.ACTUARIAL],
      });
      break;
  }
  return filter;
};

/**
 * modelRBSF - Role-based status filter for models (passes through status groups for pinpoint)
 * @param {{recentStatus: string}} model
 * @param {string?} siteRole
 */
export const modelRBSF = (model, siteRole = CONSTANTS.ROLE.CLIENT_USER) => {
  const status = model?.recentStatus;
  if (siteRole === CONSTANTS.ROLE.CLIENT_USER) {
    // These status are always in progress to client users
    if (
      [
        CONSTANTS.TAL_MODEL.STATE.MODEL_REMEDIATION_SETUP,
        CONSTANTS.TAL_MODEL.STATE.MODEL_REMEDIATION_SETUP_SUCCESS,
        CONSTANTS.TAL_MODEL.STATE.MODEL_REMEDIATION_PENDING,
      ].includes(status)
    ) {
      return CONSTANTS.TAL_MODEL.STATE_GROUPS.IN_PROGRESS;
    }
    if (status === CONSTANTS.TAL_MODEL.STATE.LIFT_CHART_GENERATION_SUCCESS) {
      if (
        model?.modelGroup?.some?.(
          (subModel) =>
            modelRBSF(subModel, siteRole) === CONSTANTS.TAL_MODEL.STATE_GROUPS.COMPLETED &&
            [null, 1, 2, 3].includes(
              subModel?.payload?.version
                ?.split?.('_')
                ?.map?.((item) => +item)
                ?.filter?.((item) => item)?.[0] ?? null
            )
        )
      ) {
        // actuarial parent models special handling - if any sub model is completed, mark completed
        return CONSTANTS.TAL_MODEL.STATE_GROUPS.COMPLETED;
      }
      const modelVersion =
        model?.payload?.version
          ?.split?.('_')
          ?.map?.((item) => +item)
          ?.filter?.((item) => item)?.[0] ?? null;
      if (modelVersion >= 4 || modelVersion === null) {
        // lift chart success is only in progress for model version 4+
        return CONSTANTS.TAL_MODEL.STATE_GROUPS.IN_PROGRESS;
      }
    }
  }
  return CONSTANTS.TAL_MODEL.STATE_GROUPINGS?.[status] ?? CONSTANTS.TAL_MODEL.STATE_GROUPS.UNKNOWN;
};
